import {
  container,
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  transition,
  boxShadow,
  drawerWidth,
  headerColor,
} from "./material-kit-react.js";
import { colors } from "../components/Theme/WebTheme";

const headerStyle = {
  appBar: {
    display: "flex",
    border: "0",
    borderRadius: "3px",
    padding: "0.625rem 0",
    marginBottom: "20px",
    color: "#555",
    width: "100%",
    backgroundColor: "#fff",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
    transition: "all 150ms ease 0s",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
    zIndex: "unset",
  },
  absolute: {
    position: "absolute",
    zIndex: "1100",
  },
  fixed: {
    position: "fixed",
    zIndex: "1100",
  },
  container: {
    ...container,
    minHeight: "50px",
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap",
  },
  flex: {
    flex: 1,
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    padding: "8px 16px",
    letterSpacing: "unset",
    "&:hover,&:focus": {
      color: "inherit",
      background: "transparent",
    },
  },
  appResponsive: {
    margin: "20px 10px",
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(156, 39, 176, 0.46)",
  },
  info: {
    backgroundColor: infoColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)",
  },
  success: {
    backgroundColor: successColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(76, 175, 80, 0.46)",
  },
  warning: {
    backgroundColor: warningColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(255, 152, 0, 0.46)",
  },
  danger: {
    backgroundColor: dangerColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(244, 67, 54, 0.46)",
  },
  rose: {
    backgroundColor: roseColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(233, 30, 99, 0.46)",
  },
  transparent: {
    backgroundColor: "transparent !important",
    boxShadow: "none",
    paddingTop: "25px",
    color: "#FFFFFF",
  },
  dark: {
    color: "#FFFFFF",
    backgroundColor: "#212121 !important",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)",
  },
  white: {
    border: "0",
    padding: "0.625rem 0",
    marginBottom: "20px",
    color: "#555",
    backgroundColor: "#fff !important",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
  },
  header: {
    backgroundColor: headerColor,
    color: colors.Header_Content,
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
  },
  drawerPaper: {
    border: "none",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: drawerWidth,
    ...boxShadow,
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    right: "0",
    left: "auto",
    visibility: "visible",
    overflowY: "visible",
    borderTop: "none",
    textAlign: "left",
    paddingRight: "0px",
    paddingLeft: "0",
    ...transition,
  },

  spacings: {
    maxWidth: "1440px",
    margin: "0 auto",
    paddingLeft: "20px",
    paddingRight: "20px",
    "@media (min-width: 768px)": {
      paddingLeft: "30px",
      paddingRight: "30px",
    },
    "@media (min-width: 1024px)": {
      paddingLeft: "90px",
      paddingRight: "90px",
    },
    "@media (min-width: 1536px)": {
      paddingLeft: "120px",
      paddingRight: "120px",
    },
  },

  headerDiv: {
    maxWidth: "1440px",
    margin: "0 auto",
    paddingLeft: "20px",
    paddingRight: "20px",
    position: "relative",
    "@media (min-width: 768px)": {
      paddingLeft: "30px",
      paddingRight: "30px",
    },
    "@media (min-width: 1024px)": {
      paddingLeft: "90px",
      paddingRight: "90px",
    },
    "@media (min-width: 1536px)": {
      paddingLeft: "120px",
      paddingRight: "120px",
    },
  },

  mobileMenu: {
    position: "absolute",
    display: "block",
    background: "#FFF",
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
    left: "-0px",
    top: "-0px",
    zIndex: "900",
    "@media (min-width: 1024px)": {
      display: "none",
    },
  },

  menuCloseIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "25px",
    paddingTop: "25px",
    paddingLeft: "25px",
  },

  mobileMenuCLose: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    paddingTop: "60px",
  },

  mobileMenuLinks: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "40px",
  },

  mobileLinksContainer: {
    color: "#222222",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    paddingBottom: "30px",
    gap: "30px",
  },

  outterContainer: {
    position: "fixed",
    width: "100vw",
    maxWidth: "100%",
    zIndex: "400",
    top: "0",
    left: "0",
    transform: "none",
    background: "#FFF",
  },

  outterScrollingContainer: {
    position: "fixed",
    width: "100vw",
    maxWidth: "100%",
    zIndex: "400",
    top: "0",
    left: "0",
    transform: "none",
    background: "#FFF",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "background-color 0.3s ease-in-out",
  },

  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#222222",
    padding: "20px 0px",
    zIndex: "400",
    "@media (min-width: 1024px)": {
      padding: "18px 0px",
    },
  },
  navLinkContainerOne: {
    display: "flex",
    gap: "50px",
    alignItems: "center",
    cursor: "pointer",
  },
  navLinkContainerTwo: {
    gap: "25px",
    alignItems: "center",
    cursor: "pointer",
    display: "none",
    "@media (min-width: 1024px)": {
      display: "flex",
    },
  },
  headerLink: {
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    display: "hidden",
    "@media (min-width: 1024px)": {
      display: "block",
    },
  },

  headerLinkP: {
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    display: "none",
    "@media (min-width: 1024px)": {
      display: "block",
    },
  },

  headerLogInButton: {
    border: "2px solid #222222",
    padding: "10px 16px",
    borderRadius: "50px",
    backgroundColor: "transparent",
    color: "#222222",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    width: "fit",
  },
  headerSignUpButton: {
    border: "2px solid #222222",
    padding: "10px 16px",
    borderRadius: "50px",
    backgroundColor: "#222222",
    color: "#FFF",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    width: "fit",
  },
  headerLangDiv: {
    display: "flex",
    gap: "3px",
    alignItems: "center",
    cursor: "pointer",
    "@media (min-width: 1024px)": {
      gap: "10px",
    },
  },
  headerLangDivSection: {
    display: "relative",
    zIndex: "400",
    cursor: "pointer",
  },

  langOptionDiv: {
    width: "100px",
    backgroundColor: "#222222",
    color: "#FFF",
    padding: "0px 16px",
    position: "absolute",
    borderRadius: "16px",
    marginLeft: "-10%",
    "@media (min-width: 1024px)": {
      marginLeft: "0px",
    },
  },

  langLinks: {
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    color: "#FFF",
    cursor: "pointer",
  },

  navLinkContainer: {
    display: "none",
    "@media (min-width: 1024px)": {
      display: "flex",
      gap: "30px",
    },
  },

  headerLogo: {
    width: "150px",
    // objectFit: "cover",

    // marginLeft: "-15px",
  },

  mobileNavLangContainer: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
    "@media (min-width: 1024px)": {
      display: "none",
    },
  },

  navLinkMenuIcon: {
    display: "block",
    "@media (min-width: 1024px)": {
      display: "none",
    },
  },

  scrolling: {
    backgroundColor: "white !important",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "background-color 0.3s ease-in-out",
  },
};

export default headerStyle;
